export interface Profile {
  profile_details: {
    id: number;
    full_name: string;
    first_name: string;
    last_name: string;
    dob: string;
    currency: string;
    profile_type: string;
    group_id: string;
    gender: string;
    is_completed: boolean;
    aum: number;
    financial_detail: FinancialDetail;
    what_brings_you_here: string[];
    advisor: Array<{
      id: number;
      uuid: string;
      created_at: string;
      type: string;
      legal_business_name: string;
      proof_of_address: string;
      sebiria_number: string;
      registration_type: string;
      corporate_address: string;
      number_of_advisors: number;
      gst_number: string;
      annual_aum: number;
      fee_model: string;
      bank_accounts: any;
      files: any;
      current_plan: any;
      agreedto_tos_at: string;
    }>;
    user: {
      id: string;
      aud: string;
      role: string;
      email: string;
      invited_at: string;
      email_confirmed_at: string;
      confirmation_sent_at: string;
      app_metadata: any;
      user_metadata: any;
      created_at: string;
      updated_at: string;
      phone: string;
    };
    risk_profile: {
      id: string;
      created_at: string;
      updated_at: string;
      member_id: string;
      answers: {
        comfort: string;
        lottery: string;
        dependency: string;
        market_drop: string;
      };
      score: number;
      profile_type: string;
    };
  };
  invite_completed_by: string;
  wellness_not_check_since: string;
  goto: string;
}

export interface FinancialDetail {
  income_per_month: number;
  spends_per_month: number;
  savings_per_month: number;
  health_insurance_coverage_amount: number;
  term_insurance_coverage_amount: number;
}
export const profileTypeMap: Record<string, string> = {
  ADVISOR: 'advisor',
  CUSTOMER: 'customer',
};
